import React from 'react';
import { Body1, Body2, Subtle } from '@xo-union/tk-ui-typography';

import { Gds_QuestionResponseData } from '../../generated/graphql';
import styles from './rsvpSummaryCard.scss';

interface Props {
  question: Gds_QuestionResponseData;
}

const TextAnswerResponseCard: React.FC<Props> = ({ question }) => {
  const responses = question.answersData?.length || 0;

  return (
    <div className={styles.textAnswerCardContainer}>
      <>
        <Body1 bold className={styles.question}>
          {question.text}
        </Body1>
        <div className={styles.responseCount}>
          {responses}
          <span>{responses > 1 ? 'responses' : 'responded'}</span>
        </div>
        <div className={styles.response}>
          {question?.answersData?.length ? (
            <>
              <Subtle> Most Recent </Subtle>
              <Body1 bold className={styles.recentResponse}>
                {`“${question.answersData[0]?.text}”`}
              </Body1>
              <Body2 className={styles.responseFrom}>
                {question?.answersData[0]?.responses && (
                  <>
                    -
                    {` ${question?.answersData[0]?.responses[0]?.firstName} ${question.answersData[0]?.responses[0]?.lastName} `}
                  </>
                )}
              </Body2>
            </>
          ) : (
            <Subtle> No Responses </Subtle>
          )}
        </div>
      </>
    </div>
  );
};

export default TextAnswerResponseCard;
